import { isNil } from 'ramda'
import React,
{ Component } from 'react'

import { Button } from '@driftt/dds'
import {
  Div,
  Footer,
  H3,
  Modal 
} from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'

class EnrollSegmentInPlaybookModal extends Component {
  render() {
    const { 
      playbooksToTarget,
      segment,
      selectedPlaybook,
      targetedPlaybook,
      selectedEnrollmentType,
      isSaving,
      open,
      onClose,
      onPlaybookSelect,
      onChooseEnrollmentType,
      onSave,
    } = this.props

    const selectOptions = playbooksToTarget.map(pb => ({
      label: pb.name,
      value: pb.id 
    }))
    const selectValue = selectOptions.filter(({ value }) => value === selectedPlaybook?.id)

    return (
      <Modal
        open={open}
        segment={segment}
        onClose={onClose}
        size="small"
      >
        <Div className="add-segment-to-pb-modal">
          <H3 className="header">Add {segment.name} to a bot playbook</H3>
          <Div className="add-segment-to-pb-modal--select">
            <Select
              label="Playbook:"
              options={playbooksToTarget.map(pb => ({
                label: pb.name,
                value: pb.id 
              }))}
              placeholder="Select or search for a bot playbook…"
              value={selectValue}
              onChange={onPlaybookSelect}
              clearable={false}
            />
          </Div>
          <Div className="add-segment-to-pb-modal--select">
            <Select
              label="Include or exclude this segment from playbook?"
              options={[{
                label: 'Include',
                value: 'notIntersectionEmpty' 
              }, {
                label: 'Exclude',
                value: 'intersectionEmpty' 
              }]}
              clearable={false}
              value={selectedEnrollmentType}
              disabled={isNil(selectedPlaybook)}
              onChange={onChooseEnrollmentType}
            />
          </Div>
          <Footer>
            <Button disabled={isNil(targetedPlaybook)} onClick={onSave}
              loading={isSaving}>Add to audience
            </Button>
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
          </Footer>
        </Div>
      </Modal>
    )
  }
}

export default EnrollSegmentInPlaybookModal
